import translations from '../../translations.json';

export function $e(msg) {
  if (msg === null || msg === undefined) return '';

  const key = msg.toLowerCase().replace(/ /g, '_');

  let lang = localStorage.getItem('fe_lang');

  if (lang === null || lang === undefined) {
    lang = navigator.language;
    if (lang.includes('-')) {
      lang = lang.split('-')[0];
    }
  }

  if (translations.hasOwnProperty(lang)) {
    if (translations[lang].hasOwnProperty(key)) {
      if (translations[lang][key] !== '') {
        return translations[lang][key];
      }
    }
  }

  return msg;
}
